import { render } from "./WutaishanPay.vue?vue&type=template&id=bdaac102&scoped=true"
import script from "./WutaishanPay.vue?vue&type=script&lang=js"
export * from "./WutaishanPay.vue?vue&type=script&lang=js"

import "./WutaishanPay.vue?vue&type=style&index=0&id=bdaac102&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bdaac102"]])

export default __exports__